// Mock IKEA product data
export const mockProducts = [
  {
    id: "BILLY001",
    sku: "BILLY-80263832",
    name: "BILLY Bookcase",
    description: "Bookcase, white, 80x28x202 cm",
    category: "Storage & Organization",
    status: "active",
    stock: 45,
    price: 79.99,
    isVisibleInCommerce: true,
    images: [
      "https://www.ikea.com/us/en/images/products/billy-bookcase-white__0625599_PE692385_S5.JPG"
    ],
    tags: ["bookcase", "storage", "living room", "bestseller"],
    reCommerceAttributes: {
      eligibleForResale: true,
      eligibleForRepair: true,
      eligibleForRental: true,
      isRefillable: false
    },
    variants: [
      {
        id: "BILLY001-WHITE",
        color: "White",
        dimensions: "80x28x202 cm",
        price: 79.99
      },
      {
        id: "BILLY001-BLACK",
        color: "Black-brown",
        dimensions: "80x28x202 cm",
        price: 89.99
      }
    ],
    createdAt: new Date("2024-01-01"),
    updatedAt: new Date("2024-03-15")
  },
  {
    id: "POANG001",
    sku: "POANG-89129308",
    name: "POÄNG Armchair",
    description: "Armchair, birch veneer/Knisa light beige",
    category: "Chairs",
    status: "active",
    stock: 28,
    price: 129.99,
    isVisibleInCommerce: true,
    images: [
      "https://www.ikea.com/us/en/images/products/poaeng-armchair-birch-veneer-knisa-light-beige__0497130_PE628957_S5.JPG"
    ],
    tags: ["armchair", "living room", "comfort", "bestseller"],
    reCommerceAttributes: {
      eligibleForResale: true,
      eligibleForRepair: true,
      eligibleForRental: true,
      isRefillable: false
    },
    variants: [
      {
        id: "POANG001-BEIGE",
        color: "Light beige",
        frame: "Birch veneer",
        price: 129.99
      },
      {
        id: "POANG001-BROWN",
        color: "Dark brown",
        frame: "Black-brown",
        price: 139.99
      }
    ],
    createdAt: new Date("2024-01-01"),
    updatedAt: new Date("2024-03-15")
  },
  {
    id: "MALM001",
    sku: "MALM-89129307",
    name: "MALM Bed frame",
    description: "Bed frame, high, white/Luröy, 160x200 cm",
    category: "Beds",
    status: "active",
    stock: 15,
    price: 249.99,
    isVisibleInCommerce: true,
    images: [
      "https://www.ikea.com/us/en/images/products/malm-bed-frame-high-white-luroey__0749130_PE745499_S5.JPG"
    ],
    tags: ["bed", "bedroom", "furniture", "bestseller"],
    reCommerceAttributes: {
      eligibleForResale: true,
      eligibleForRepair: true,
      eligibleForRental: true,
      isRefillable: false
    },
    variants: [
      {
        id: "MALM001-WHITE",
        color: "White",
        size: "160x200 cm",
        price: 249.99
      },
      {
        id: "MALM001-BLACK",
        color: "Black-brown",
        size: "160x200 cm",
        price: 269.99
      }
    ],
    createdAt: new Date("2024-01-01"),
    updatedAt: new Date("2024-03-15")
  },
  {
    id: "KALLAX001",
    sku: "KALLAX-80275887",
    name: "KALLAX Shelf unit",
    description: "Shelf unit, white, 77x147 cm",
    category: "Storage & Organization",
    status: "active",
    stock: 32,
    price: 89.99,
    isVisibleInCommerce: true,
    images: [
      "https://www.ikea.com/us/en/images/products/kallax-shelf-unit-white__0644757_PE702939_S5.JPG"
    ],
    tags: ["shelving unit", "storage", "living room", "bestseller"],
    reCommerceAttributes: {
      eligibleForResale: true,
      eligibleForRepair: true,
      eligibleForRental: true,
      isRefillable: false
    },
    variants: [
      {
        id: "KALLAX001-WHITE",
        color: "White",
        dimensions: "77x147 cm",
        price: 89.99
      },
      {
        id: "KALLAX001-BLACK",
        color: "Black-brown",
        dimensions: "77x147 cm",
        price: 99.99
      }
    ],
    createdAt: new Date("2024-01-01"),
    updatedAt: new Date("2024-03-15")
  },
  {
    id: "LACK001",
    sku: "LACK-30449908",
    name: "LACK Side table",
    description: "Side table, white, 55x55 cm",
    category: "Tables",
    status: "active",
    stock: 50,
    price: 9.99,
    isVisibleInCommerce: true,
    images: [
      "https://www.ikea.com/us/en/images/products/lack-side-table-white__0702210_PE724350_S5.JPG"
    ],
    tags: ["table", "living room", "affordable", "bestseller"],
    reCommerceAttributes: {
      eligibleForResale: true,
      eligibleForRepair: true,
      eligibleForRental: true,
      isRefillable: false
    },
    variants: [
      {
        id: "LACK001-WHITE",
        color: "White",
        dimensions: "55x55 cm",
        price: 9.99
      },
      {
        id: "LACK001-BLACK",
        color: "Black",
        dimensions: "55x55 cm",
        price: 9.99
      }
    ],
    createdAt: new Date("2024-01-01"),
    updatedAt: new Date("2024-03-15")
  }
]; 